import TrackingHttp from '../../trackingHttp'

class VehicleRouteServices {
  static async createVehicleRoute(data) {
    return TrackingHttp.post('/vehicle-routes', data);
  }

  static async getAllVehicleRoutes() {
    return TrackingHttp.get('/vehicle-routes');
  }

  static async getVehicleRoutesByOwnerId(ownerId) {
    return TrackingHttp.get(`/vehicle-routes/owner/${ownerId}`);
  }

  static async getVehicleRouteById(id) {
    return TrackingHttp.get(`/vehicle-routes/${id}`);
  }

  static async updateVehicleRouteById(id, data) {
    return TrackingHttp.update(`/vehicle-routes/${id}`, data);
  }

  static async deleteVehicleRouteById(id) {
    return TrackingHttp.delete(`/vehicle-routes/${id}`);
  }
}

export default VehicleRouteServices;
